<template>
  <div class="container">
    <div class="card">
      <div class="content-page">
        <p v-html="content.outline" class="pre-line"></p>
        <div v-html="content.content"></div>
      </div>      
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      content: {}
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios
        .get("content/" + this.$route.params.slug, {})
        .then(response => {
          this.content = response.data;
          if (this.content) {
            this.$store.dispatch("updateBanner", this.content);
          }
        })
        .catch(this.showError);
    }
  },
  watch: {
    $route() {
        this.fetchData()
    }
  }
};
</script>
